export default "__VITE_ASSET__DMncr2E2__"